<template>
  <div class="main container">
    <div class="logo col-md-12 text-center">
      <img src="./../../assets/logo-10.png">
    </div>
    <div class="col-md-12 text-center">
      <h4 class="highlight-color">{{ $t('message.login') }}</h4>
      <p class="highlight-color">{{ $t('message.intro1') }}</p>
    </div>
    <div
      v-if="$store.state.app.error_message"
      class="col-md-6 form p-0"
      style="background: none;">
      <div
        v-if="$store.state.app.error_message == 'not found email or username.'"
        class="alert alert-danger m-0"
        role="alert"
      >
        <span>
          {{ $t('message.notfoundemailorusername') }}
        </span>
      </div>
      <div
        v-if="$store.state.app.error_message == 'password is invalid.'"
        class="alert alert-danger m-0"
        role="alert"
      >
        <span>
          {{ $t('message.passwordisinvalid') }}
        </span>
      </div>
      <div
        v-if="$store.state.app.error_message == 'email is not verify.'"
        class="alert alert-warning m-0 d-flex justify-content-between align-items-center"
        role="alert"
      >
        <span>
          {{ $t('message.userisnotverifyemail') }}
        </span>
        <button
          class="btn btn-sm btn-web"
          @click="openVerifyEmailModal"
        >
          {{ $t('message.getverifyemaillink') }}
        </button>
      </div>
      <div
        v-if="$store.state.app.error_message == 'SHOP_IS_SUSPENDED'"
        class="alert alert-danger m-0"
        role="alert"
      >
        <span>
          {{ $t('message.shopissuspended') }}
        </span>
      </div>
      <div
        v-if="$store.state.app.error_message == 'SHOP_IS_SUSPENDED'"
        class="alert alert-danger m-0"
        role="alert"
      >
        <span>
          {{ $store.state.app.error_message }}
        </span>
      </div>
    </div>
    <div class="col-md-6 form">
      <div class="form-group">
        <!-- <label>{{ $t('message.email') }} / {{ $t('message.username') }}</label> -->
        <input
          :placeholder="$t('placeholder.usernameoremail')"
          v-model="form1.email"
          type="text"
          class="form-control">
      </div>
      <div
        class="form-group"
        style="position: relative;">
        <!-- <label>{{ $t('message.password') }}</label> -->
        <input
          :placeholder="$t('placeholder.password')"
          v-model="form1.password"
          type="password"
          class="form-control">
        <div class="wrapper-forgotpassword">
          <button @click="openForgotPasswordModal">{{ $t('button.forgotpassword') }}</button>
        </div>
      </div>
      <div class="form-group">
        <button
          v-if="!$store.state.app.loading || state.is_open_modal"
          :disabled="disabledLogin"
          type="submit"
          class="btn btn-web btn-block"
          @click="login()">
          {{ $t('message.login') }}
        </button>
        <button
          v-else
          type="submit"
          class="btn btn-web btn-block disabled">
          <i class="fas fa-spinner spin"/>
        </button>
      </div>
      <div
        class="form-group text-center mb-0"
        style="font-size: 11px;color: #495057;">
        <i class="fas fa-lock"/>
        256 bit SSL Encryption
      </div>
    </div>
    <div class="col-md-12 text-center">
      <p
        v-if="$route.query.app != 'apps.inventory'"
        class="text-white mb-1">
        {{ $t('message.donthaveaccount') }}
        <router-link
          :to="{
            name: 'SignUp',
            query: {
              ...$route.query,
              token: undefined,
            }
          }"
          class="text-white">
          {{ $t('message.registerhere') }}
        </router-link>
      </p>
      <DropdownLang/>
    </div>

    <div
      id="forgotpasswordModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('button.forgotpassword') }}
            </h5>
          </div>
          <div class="modal-body">
            <section
              v-if="!form2.send_email_success"
              class="m-0">
              <div class="form-row">
                <div class="col-12">
                  <div
                    v-if="form2.send_email_error"
                    class="alert alert-warning"
                    role="alert">
                    {{ $t('message.somethingwentwrongtrytosendemailagain') }}
                  </div>
                  <div class="form-group m-0">
                    <label>{{ $t('message.wewillsendlinktoyouremailtoresetpassword') }}</label>
                    <input
                      :class="[{'is-invalid': state.is_invalid_email}]"
                      :placeholder="$t('placeholder.email')"
                      :disabled="$store.state.app.loading"
                      v-model="form2.email"
                      type="text"
                      class="form-control"
                      @keyup="form2.email.trim().length == 0 ? state.is_invalid_email = true : state.is_invalid_email = false"
                      @change="!validateEmail(form2.email) ? state.is_invalid_email = true : state.is_invalid_email = false">
                    <div class="invalid-feedback">
                      {{ $t('message.emailisinvalid') }}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              v-if="form2.send_email_success"
              class="m-0">
              <p class="text-success mb-1">
                {{ $t('message.sendlinkresetpasswordsuccess') }} <i class="far fa-check-circle"/>
              </p>
              <p class="m-0">
                {{ $t('message.notetokenexpired2') }}
              </p>
            </section>
          </div>
          <div class="modal-footer">
            <template>
              <div v-if="!form2.send_email_success">
                <button
                  :disabled="$store.state.app.loading"
                  type="button"
                  class="btn btn-light"
                  @click="closeForgotPasswordModal()">
                  {{ $t('button.cancel') }}
                </button>
                <button
                  :disabled="disabledForgotPassSendMail"
                  type="button"
                  class="btn btn-web"
                  @click="clickToSendMail_forgotPassword()">
                  <span v-if="$store.state.app.loading"><i class="fas fa-spinner spin"/></span>
                  <span v-else>{{ $t('button.send') }}</span>
                </button>
              </div>
              <div v-if="form2.send_email_success">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="closeForgotPasswordModal()">
                  {{ $t('button.close') }}
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div
      id="verifyemailModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('message.verifyemail') }}
            </h5>
          </div>
          <div class="modal-body">
            <section
              v-if="!form3.send_email_success"
              class="m-0">
              <div class="form-row">
                <div class="col-12">
                  <div
                    v-if="form3.send_email_error"
                    class="alert alert-warning"
                    role="alert">
                    {{ $t('message.somethingwentwrongtrytosendemailagain') }}
                  </div>
                  <div class="form-group m-0">
                    <label>{{ $t('message.wewillsendverifylinktoyouremail') }}</label>
                    <input
                      :class="[{'is-invalid': state.is_invalid_email}]"
                      :placeholder="$t('placeholder.email')"
                      :disabled="$store.state.app.loading"
                      v-model="form3.email"
                      type="text"
                      class="form-control"
                      @keyup="form3.email.trim().length == 0 ? state.is_invalid_email = true : state.is_invalid_email = false"
                      @change="!validateEmail(form3.email) ? state.is_invalid_email = true : state.is_invalid_email = false">
                    <div class="invalid-feedback">
                      {{ $t('message.emailisinvalid') }}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              v-if="form3.send_email_success"
              class="m-0">
              <p class="text-success mb-0">
                {{ $t('message.sendlinkresetpasswordsuccess') }} <i class="far fa-check-circle"/>
              </p>
            </section>
          </div>
          <div class="modal-footer">
            <template>
              <div v-if="!form3.send_email_success">
                <button
                  :disabled="$store.state.app.loading"
                  type="button"
                  class="btn btn-light"
                  @click="closeVerifyEmailModal()">
                  {{ $t('button.cancel') }}
                </button>
                <button
                  :disabled="disabledVerifySendMail"
                  type="button"
                  class="btn btn-web"
                  @click="clickToSendMail_VerifyEmail()">
                  <span v-if="$store.state.app.loading"><i class="fas fa-spinner spin"/></span>
                  <span v-else>{{ $t('button.send') }}</span>
                </button>
              </div>
              <div v-if="form3.send_email_success">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="closeVerifyEmailModal()">
                  {{ $t('button.close') }}
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import DropdownLang from '../custom/DropdownLang.vue'
const jwt = require('jsonwebtoken')

export default {
  name: 'SignIn',

  components: {
    DropdownLang,
  },

  data () {
    return {
      form1: {
        email: '',
        password: '',
      },

      form2: {
        send_email_success: false,
        send_email_error: false,
        email: '',
      },
      originalForm2: null,

      form3: {
        send_email_success: false,
        send_email_error: false,
        email: '',
      },
      originalForm3: null,

      state: {
        is_invalid_email: false,
        is_open_modal: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
    disabledLogin () {
      return !!(this.form1.email.trim().length == 0 || this.form1.password.trim().length == 0)
    },
    disabledForgotPassSendMail () {
      let email = this.form2.email.trim()
      return !!(email.length == 0 || !this.validateEmail(email) || this.$store.state.app.loading)
    },
    disabledVerifySendMail () {
      let email = this.form3.email.trim()
      return !!(email.length == 0 || !this.validateEmail(email) || this.$store.state.app.loading)
    },
  },
  created: function () {
    // set default email
    let that = this
    if (this.$route.query.token) {
      jwt.verify(this.$route.query.token, this.project.config.token.secret, function (err, decoded) {
        if (err) return
        if (decoded.email) {
          that.form1.email = decoded.email
          that.form1.password = decoded.password
        }
        that.login()
      })
    }

    // set originalForm2
    this.originalForm2 = _.cloneDeep(this.form2)
    this.originalForm3 = _.cloneDeep(this.form3)
  },
  mounted: function () {
    // set section
    this.$store.dispatch('setSection', 'login')
    // set title
    this.setTabTitle(this.$t('message.title_signin'))
    // event keyboard
    window.addEventListener('keyup', this.handleKeyup, false)
    // set modal
    this.setModal('#forgotpasswordModal')
    this.setModal('#verifyemailModal')
  },
  destroyed: function () {
    // remove event keyboard
    window.removeEventListener('keyup', this.handleKeyup, false)
    // leavePage
    this.leavePage(this.$Progress, [])
  },
  methods: {
    login () {
      this.$store.dispatch('Login', {
        email: this.form1.email.toLowerCase().trim(),
        password: this.form1.password,
        token: this.$route.query.token,
      })
    },
    switchLang (lang) {
      // change lang
      this.$i18n.locale = lang
      // switch lang
      this.$store.dispatch('switchLang', lang)
    },
    handleKeyup (e) {
      if (e.key == 'Enter') {
        if (!this.disabledLogin && !this.state.is_open_modal) {
          this.login()
        }
      }
    },
    openForgotPasswordModal () {
      $('#forgotpasswordModal').modal('show')
      // set state
      this.state.is_open_modal = true
    },
    closeForgotPasswordModal () {
      $('#forgotpasswordModal').modal('hide')
      // set state
      this.state.is_open_modal = false
      this.state.is_invalid_email = false
      // set to original
      this.form2 = _.cloneDeep(this.originalForm2)
    },
    async clickToSendMail_forgotPassword () {
      // reset state
      this.form2.send_email_error = false

      let dataSet = {
        'email': this.form2.email.toLowerCase().trim(),
        'lang_code': this.lang,
      }

      let res = await this.$store.dispatch('forgotPasswordSend', dataSet)

      if (!res.success) {
        this.form2.send_email_error = true
      } else {
        this.form2.send_email_success = true
      }
    },
    openVerifyEmailModal () {
      $('#verifyemailModal').modal('show')
      // set state
      this.state.is_open_modal = true
    },
    closeVerifyEmailModal () {
      $('#verifyemailModal').modal('hide')
      // set state
      this.state.is_open_modal = false
      this.state.is_invalid_email = false
      // set to original
      this.form3 = _.cloneDeep(this.originalForm3)
    },
    async clickToSendMail_VerifyEmail() {
      // reset state
      this.form3.send_email_error = false

      let res = await this.$store.dispatch('verifyEmailSend', {
        email: this.form3.email.toLowerCase().trim(),
        lang_code: 'th',
      })

      if (!res.success) {
        this.form3.send_email_error = true
      } else {
        this.form3.send_email_success = true
      }
    },
  },
}
</script>
<style scoped>
.main {

}
.logo {
  margin: 25px 0 25px 0;
}
.form {
  padding: 25px 25px 10px 25px;
  max-width: 400px;
  margin: 25px auto;
  background: #FFF;
  border-radius: 2px;
}
.text {
  color: #282D35;
}
a {
  text-decoration: underline;
}
.wrapper-forgotpassword {
  position: absolute;
  top: 0;
  right: 2px;
  height: 35px;
}
.wrapper-forgotpassword button {
  height: 100%;
  background: none;
  border: none;
  font-size: 13px;
  padding: 0 8px 0 8px;
  cursor: pointer;
  color: #ccc;
  text-decoration: underline;
}
.wrapper-forgotpassword button:focus {
  outline: none;
}.wrapper-forgotpassword button:hover {
  color: rgba(0,0,0,.45);
}
</style>



// WEBPACK FOOTER //
// src/components/account/SignIn.vue